import { render, staticRenderFns } from "./FavouritesButton.vue?vue&type=template&id=7c89f3ee&scoped=true&"
import script from "./FavouritesButton.vue?vue&type=script&lang=js&"
export * from "./FavouritesButton.vue?vue&type=script&lang=js&"
import style0 from "./FavouritesButton.vue?vue&type=style&index=0&id=7c89f3ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89f3ee",
  null
  
)

export default component.exports